'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

BaseDataService=class BaseDataService extends BaseService{
constructor($timeout){
super();
this._$timeout=$timeout;
this._pendingUpdate=void 0;
}

async _update(){
throw new Error('abstract method not implemented');
}

_clearCache(){
throw new Error('abstract method not implemented');
}

_clearPersistentData(){
throw new Error('abstract method not implemented');
}

get isUpdating(){
return _.exists(this._pendingUpdate);
}

clearCache(){
if(_.exists(this._pendingUpdate)){
this._pendingUpdate.cancelled=!0;
this._pendingUpdate=void 0;
}
this._clearCache();
}

clearAll(){
this.clearCache();
this._clearPersistentData();
}

async update(...args){
let cancellationToken=this._startUpdate();
try{
await this._update(cancellationToken,...args);
}finally{
this._$timeout(()=>{
this._completeUpdate(cancellationToken);
});
}
}

_startUpdate(){
if(_.exists(this._pendingUpdate)){
this._pendingUpdate.cancelled=!0;
}
this._pendingUpdate={cancelled:!1};
return this._pendingUpdate;
}

_completeUpdate(cancellationToken){
if(this._pendingUpdate===cancellationToken){
this._pendingUpdate=void 0;
}
}};


module.exports=BaseDataService;
//# sourceMappingURL=baseDataService.js.map
